import { useEffect, useRef, useState } from 'react';

export function useIsPressed<T extends HTMLElement = any>() {
    const ref = useRef<T>(null);
    const mounted = useRef<boolean>(false);
    const [pressed, setPressed] = useState(false);

    useEffect(() => {
        mounted.current = true;
    }, []);

    useEffect(() => {
        const node = ref.current;

        const onPressed = () => {
            setPressed(true);
        };

        const onFinish = () => {
            setPressed(false);
        };

        node?.addEventListener('mousedown', onPressed);
        node?.addEventListener('touchstart', onPressed, { passive: false });
        node?.addEventListener('mouseup', onFinish);
        node?.addEventListener('touchend', onFinish, { passive: false });

        return () => {
            if (node) {
                node.removeEventListener('mousedown', onPressed);
                node.removeEventListener('touchstart', onPressed);
                node.removeEventListener('mouseup', onFinish);
                node.removeEventListener('touchend', onFinish);
            }
        };
    }, []);

    return { ref, pressed };
}
